module.exports = __webpack_public_path__ + "static/media/udemy-javascript.8547cf84.jpg";